<form
  [formGroup]="form"
  class="form-group d-flex flex-column row align-items-center"
>
  <div class="form-group col-12 col-md-10 col-lg-6">
    <input
      formControlName="authority"
      (input)="add()"
      required
      class="form-control"
      type="text"
      name=""
      id=""
      [class.is-invalid]="isInvalid('authority')"
    />
    <small
      class="form-text text-muted"
      i18n="
        Helper text for onboarding terminology screen and organisation settings
        @@onboarding-terminology-4"
    >
      What does your organisation call the person in the main key role for each
      circle? e.g. Lead, Authority, Driver, Lead link, Source.
    </small>
  </div>
  <div class="form-group col-12 col-md-10 col-lg-6">
    <input
      formControlName="helper"
      (input)="add()"
      required
      class="form-control"
      type="text"
      name=""
      id=""
      [class.is-invalid]="isInvalid('helper')"
    />
    <small
      class="form-text text-muted"
      i18n="
        Helper text for onboarding terminology screen and organisation settings
        @@onboarding-terminology-5"
    >
      And what do you call others contributing to an circle? e.g. Contributor,
      Helper, Role-holder, Sub-source.
    </small>
  </div>
</form>
